
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { DateInput, NumericInput } from '../../../../../../../../../components/form/form';
import styles from './optional-redemption-dates.module.scss'
import addButton from '../../../../../../../../../assets/add-button.svg';
import closeButton from '../../../../../../../../../assets/close.svg';
import { PATTERN_ALPHA_NUMERIC_SPACE } from '../../../../../../../../../helpr/constants';

const OptionalRedemptionDates = ({securityFormState, isPublished}) => {
  const { getDynamicField, getTextFieldPropsDynamic, setDynamicField, forceSetField } = securityFormState;

  /*
    Build date for caldendar constraints Advance date by 1 day (forward date)
    and remove constraint if termsheet is already published.
  */
  const today = new Date();
  today.setDate(today.getDate() + 1);
  const dateToday = isPublished? null: [
    today.getFullYear(),
    ('0'+ parseInt(today.getMonth() +1).toString()).slice(-2),('0'+today.getDate()).slice(-2)
  ].join('-');


  const addRedemptionDetail = () => {
    const redemptionDetail = getDynamicField('redemptionDetail').concat({
      optional_redemption_date: {value: '', style: {}},
      optional_redemption_price: {value: '', style: {}},
    })
    setDynamicField('redemptionDetail', redemptionDetail);
  }

  const removeRedemptionDetail = (index) => {
    const redemptionDetail = getDynamicField('redemptionDetail');;
    var array = [...redemptionDetail];
    array.splice(index, 1);
    setDynamicField('redemptionDetail', array);
  }

  const renderButton = (index) => {
    const fieldLength = getDynamicField('redemptionDetail').length;
    if( fieldLength > 1 && index < fieldLength - 1 ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>removeRedemptionDetail(index)} src={closeButton}/>
        </div>
      )
    }
    if( (fieldLength - 1) == index ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>addRedemptionDetail(index)} src={addButton}/>
        </div>
      )
    }
  }

  return (
    <div className={styles['redemption-dates']}>
      {
        getDynamicField('redemptionDetail').map((_,index)=>{
          return (
            <>
              <Row key={'redemptionDetail-'+index} className="mt-1">
                <Col sm={6} lg={3}>
                  <DateInput inputProps={getTextFieldPropsDynamic('redemptionDetail','optional_redemption_date',index)} min={dateToday}>
                    Optional Redemption Date:
                  </DateInput>
                </Col>
                <Col sm={6} lg={3}>
                  <NumericInput inputProps={getTextFieldPropsDynamic('redemptionDetail','optional_redemption_price',index)} decimalLimit={4} numberLimit={1000} variant="default">
                    Optional Redemption Price (%):
                  </NumericInput>
                </Col>
                { renderButton(index) }
              </Row>
            </>
          )
        })
      }
    </div>
  )
}

export default OptionalRedemptionDates;


